import actions from "./actions";
import deleteactions from "./deleteactions";
import send from "./send";

export default (
  state = {
    isFetchingRefTypes: false,
    reftypes: [],
    reftypesListError: "",

    isDeletingRefTypes: false,
    deletedRefTypes: null,
    deletingRefTypesError: "",

    isFetchingSkillCategories: false,
    skillCategories: [],
    skillCategoriesError: "",

    isDeletingSkillCategories: false,
    deletedSkillCategories: null,
    deletingSkillCategoriesError: "",

    isFetchingDictItem: false,
    itemCard: null,
    itemCardError: "",

    isCreatingItem: false,
    createdItem: null,
    itemCreationError: "",

    isUpdatingItem: false,
    updatedItem: null,
    itemUpdatingError: ""
  },
  action
) => {
  switch (action.type) {
    case actions.GET_REFERENCE_TYPES_REQUEST:
      return {
        ...state,
        isFetchingRefTypes: action.isFetchingRefTypes
      };
    case actions.GET_REFERENCE_TYPES_COMPLETED:
      return {
        ...state,
        isFetchingRefTypes: action.isFetchingRefTypes,
        reftypes: action.reftypes
      };
    case actions.GET_REFERENCE_TYPES_ERROR:
      return {
        ...state,
        isFetchingRefTypes: action.isFetchingRefTypes,
        reftypesListError: action.reftypesListError
      };

    case actions.GET_SKILL_CATEGORIES_REQUEST:
      return {
        ...state,
        isFetchingSkillCategories: action.isFetchingSkillCategories
      };
    case actions.GET_SKILL_CATEGORIES_COMPLETED:
      return {
        ...state,
        isFetchingSkillCategories: action.isFetchingSkillCategories,
        skillCategories: action.skillCategories
      };
    case actions.GET_SKILL_CATEGORIES_ERROR:
      return {
        ...state,
        isFetchingSkillCategories: action.isFetchingSkillCategories,
        skillCategoriesError: action.skillCategoriesError
      };

    case deleteactions.DELETE_REFERENCE_TYPES_REQUEST:
      return {
        ...state,
        isDeletingRefTypes: action.isDeletingRefTypes
      };
    case deleteactions.DELETE_REFERENCE_TYPES_COMPLETED:
      return {
        ...state,
        isDeletingRefTypes: action.isDeletingRefTypes,
        deletedRefTypes: action.deletedRefTypes
      };
    case deleteactions.DELETE_REFERENCE_TYPES_ERROR:
      return {
        ...state,
        isDeletingRefTypes: action.isDeletingRefTypes,
        deletingRefTypesError: action.deletingRefTypesError
      };

    case deleteactions.DELETE_SKILL_CATEGORY_REQUEST:
      return {
        ...state,
        isDeletingSkillCategories: action.isDeletingSkillCategories
      };
    case deleteactions.DELETE_SKILL_CATEGORY_COMPLETED:
      return {
        ...state,
        isDeletingSkillCategories: action.isDeletingSkillCategories,
        deletedSkillCategories: action.deletedSkillCategories
      };
    case deleteactions.DELETE_SKILL_CATEGORY_ERROR:
      return {
        ...state,
        isDeletingSkillCategories: action.isDeletingSkillCategories,
        deletingSkillCategoriesError: action.deletingSkillCategoriesError
      };

    case actions.GET_DICT_ITEM_REQUEST:
      return {
        ...state,
        isFetchingDictItem: action.isFetchingDictItem
      };
    case actions.GET_DICT_ITEM_COMPLETED:
      return {
        ...state,
        isFetchingDictItem: action.isFetchingDictItem,
        itemCard: action.itemCard
      };
    case actions.GET_DICT_ITEM_ERROR:
      return {
        ...state,
        isFetchingDictItem: action.isFetchingDictItem,
        itemCardError: action.itemCardError
      };

      case send.CREATE_DICT_ITEM_REQUEST:
        return {
          ...state,
          isCreatingItem: action.isCreatingItem
        };
      case send.CREATE_DICT_ITEM_COMPLETED:
        return {
          ...state,
          isCreatingItem: action.isCreatingItem,
          createdItem: action.createdItem
        };
      case send.CREATE_DICT_ITEM_ERROR:
        return {
          ...state,
          isCreatingItem: action.isCreatingItem,
          itemCreationError: action.itemCreationError
        };

      case send.UPDATE_DICT_ITEM_REQUEST:
        return {
          ...state,
          isUpdatingItem: action.isUpdatingItem
        };
      case send.UPDATE_DICT_ITEM_COMPLETED:
        return {
          ...state,
          isUpdatingItem: action.isUpdatingItem,
          updatedItem: action.updatedItem
        };
      case send.UPDATE_DICT_ITEM_ERROR:
        return {
          ...state,
          isUpdatingItem: action.isUpdatingItem,
          itemUpdatingError: action.itemUpdatingError
        };

    default:
      return state;
    }
};
